import React, { useCallback, useEffect, useState } from 'react';
import { DebugContext } from 'App';
import { isMobile } from 'react-device-detect';
import {
	NavigationWrapper,
	SessionWrapper,
	TargetsAllianzUtilsWrapper,
	UiWrapper,
} from '@coinscrap/webapp-core';
import { MainModal } from 'components/MainModal/MainModal';
import { useGetError } from 'hooks/useGetError';

export const useTowns = (targetId, postalCode, trigger, setTrigger, customOnError = undefined) => {
	const { openModal } = UiWrapper.use();
	const { navigateTo } = NavigationWrapper.use();
	const { clearSession } = SessionWrapper.use();
	const isDebug = React.useContext(DebugContext);
	const { getTowns } = TargetsAllianzUtilsWrapper.use();
	const getError = useGetError();

	const onError = useCallback(
		(e) => {
			openModal(
				() => (
					<MainModal
						type="error"
						text={'Ha ocurrido un error. Recargue la página por favor.' || getError(e)}
					/>
				),
				{
					disableClickAway: true,
					closeButton: true,
					modalClass: isMobile ? 'modal-xl' : 'modal-main',
					key: 'modal-useTowns-KO',
				},
			);
		},
		[getError, openModal],
	);

	const [startProcess, setStartProcess] = useState(false);

	const [towns, setTowns] = useState(null);
	const [loadingTowns, setLoadingTowns] = useState(null);
	const [errorTowns, setErrorTowns] = useState(null);

	useEffect(() => {
		if (postalCode.length === 5) {
			setStartProcess(true);
		}
		return () => {};
	}, [postalCode]);

	const getCoreTowns = useCallback(
		async (targetId, postalCode) => {
			if (!postalCode || postalCode.length < 5) return;
			try {
				setErrorTowns(null);
				setLoadingTowns('Obteniendo poblaciones');

				let towns;
				try {
					towns = await getTowns(targetId, postalCode);
				} catch (e) {
					console.log('❌ ERROR', e);
					setTowns([]);
					if (e.safeMessage.includes('No existen poblaciones')) {
						setErrorTowns('El código postal introducido no es válido');
					} else {
						if (customOnError) {
							customOnError(
								e,
								setTrigger,
								openModal,
								navigateTo,
								isDebug,
								clearSession,
							);
						} else {
							onError(e);
						}
					}
					return;
				}

				console.log('✅ getTowns', towns);

				if (towns) {
					// PROFESSION QUESTIONS
					setTowns(towns);
				} else {
					setTowns([]);
				}
			} catch (e) {
				if (customOnError) {
					customOnError(e, setTrigger, openModal, navigateTo, isDebug, clearSession);
				} else {
					onError(e);
				}
			} finally {
				setLoadingTowns(undefined);
			}
		},
		[
			clearSession,
			customOnError,
			getTowns,
			isDebug,
			navigateTo,
			onError,
			openModal,
			setTrigger,
		],
	);

	useEffect(() => {
		if (startProcess && postalCode) {
			getCoreTowns(targetId, postalCode);
		}
		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [startProcess, postalCode, trigger]);

	return { loadingTowns, towns, errorTowns };
};
